import { useEffect } from 'react';
import { InfiniteQueryObserverResult } from 'react-query';
import { useVoicemailDetailsShallowStore } from '../../stores/voicemail-details-store';
import { VoicemailInfiniteQueryData } from '../all-calls/types';

export const useSyncDetailsPanel = ({
  shouldSync,
  instanceId,
  toggleRowSelected,
  getNextPage,
  markCurrentRowSelected,
}: {
  shouldSync: boolean;
  instanceId: string;
  toggleRowSelected: (id: string, set: boolean, index?: number) => void;
  getNextPage?: () => Promise<InfiniteQueryObserverResult<VoicemailInfiniteQueryData, unknown>>;
  markCurrentRowSelected: () => void;
}) => {
  const { setInstanceId, setGetNextPage, setToggleRowSelected } = useVoicemailDetailsShallowStore(
    'setInstanceId',
    'setGetNextPage',
    'setToggleRowSelected'
  );
  useEffect(() => {
    /**
     * This effect is to update the slide panel context with the new rows from the new table instance when the table instance changes.
     * The table instance will change if the user navigates away from the voicemail table, while having the transcription panel open.
     *
     * If we don't do this, each row's `toggleRowSelected` will not work as expected, since they are tied to the stale table instance.
     */
    if (shouldSync) {
      markCurrentRowSelected();

      setInstanceId(instanceId);
      setGetNextPage(getNextPage);
      setToggleRowSelected(toggleRowSelected);
    }
  }, [
    shouldSync,
    markCurrentRowSelected,
    instanceId,
    toggleRowSelected,
    getNextPage,
    setInstanceId,
    setGetNextPage,
    setToggleRowSelected,
  ]);
};
